import { Injectable } from '@angular/core';
import { environment } from './../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchEngineService {

  private facilitiesUrl = `${environment.backendRoot}/webresources/frontend/entity.facilitygroup/`;
  private roomFacilitiesUrl = `${environment.backendRoot}/webresources/frontend/entity.roompropertygroup/`;
  private optionalCategoriessUrl = `${environment.backendRoot}/webresources/frontend/entity.optionalextracategory/`;
  private OptionalSubcategoriesUrl = `${environment.backendRoot}/webresources/frontend/entity.optionalextrasubcategory/`;
  private RequestUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingrequest/createRequest/`;
  private searchResultsUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingoffer/getSearchResults/`;
  private requestsResultsUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingrequest/sendRequests/`;
  private offersUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingoffer/findAllOffersForUserId/`;
  private existsNewOfferUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingoffer/if_exists_new_offer/`;

  constructor(private http: HttpClient) { }

  getFacilities(): Observable<any> {
    return this.http.get(this.facilitiesUrl,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
      }
    );
  }

  getRoomFacilities(): Observable<any> {
    return this.http.get(this.roomFacilitiesUrl,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
      }
    );
  }

  getOptionalCategories(): Observable<any> {
    return this.http.get(this.optionalCategoriessUrl,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
      }
    );
  }

  getOptionalSubcategories(): Observable<any> {
    return this.http.get(this.OptionalSubcategoriesUrl,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
      }
    );
  }

  sendRequest(data) {
    const url = this.RequestUrl + encodeURIComponent(encodeURIComponent(JSON.stringify(data)));
    // console.log(decodeURIComponent(decodeURIComponent(url)));
    return this.http.get(url,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
      }
    );
  }
  getResults(data) {
    const url = this.searchResultsUrl + encodeURIComponent(encodeURIComponent(JSON.stringify(data)));
    // console.log(decodeURIComponent(decodeURIComponent(url)));
    return this.http.post(url,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
      }
    );
  }
  sendRequests(data) {
    const url = this.requestsResultsUrl + encodeURIComponent(encodeURIComponent(JSON.stringify(data)));
    // console.log(decodeURIComponent(decodeURIComponent(url)));
    return this.http.get(url,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
      }
    );
  }
  getOffers(offerId, minPrice, maxPrice, offerPage): Observable<any> {
    const url = this.offersUrl + offerId + '/' + minPrice + '/' + maxPrice + '/' + offerPage;
    return this.http.get(url,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
      }
    );
  }
  getIfNewOfferExists(offerId, now): Observable<any> {
    const url = this.existsNewOfferUrl + offerId + '/' + now;
    return this.http.get(url,
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
      }
    );
  }
  getTravellerLocation(): Observable<any> {
    const url = 'https://api.ipify.org?format=json';
    return this.http.get(url);
  }

  getCountry(ip: any): Observable<any> {
    const url = 'https://ipapi.co/' + ip + '/json/';
    return this.http.get(url);
  }
}
